import { create } from "zustand";

export type TrackerKind =
  | "ingest"
  | "export"
  | "recluster"
  | "conceptualize"
  | "print_web_pdf";

export interface Tracker {
  id: string; // job id
  kind: TrackerKind;
  title: string;
  docId?: string;
  status: "queued" | "running" | "done" | "failed";
  stages?: Record<string, string>; // ingest: live stage_status
  error?: string | null;
  result?: Record<string, unknown> | null;
  startedAt: number;
}

interface ActivityState {
  trackers: Tracker[];
  upsert: (t: Partial<Tracker> & { id: string }) => void;
  remove: (id: string) => void;
  activeForDoc: (docId: string) => boolean;
}

export const useActivity = create<ActivityState>((set, get) => ({
  trackers: [],

  upsert: (patch) =>
    set((s) => {
      const existing = s.trackers.find((t) => t.id === patch.id);
      if (existing) {
        return {
          trackers: s.trackers.map((t) => (t.id === patch.id ? { ...t, ...patch } : t)),
        };
      }
      return {
        trackers: [
          {
            kind: "ingest",
            title: "job",
            status: "queued",
            startedAt: Date.now(),
            ...patch,
          } as Tracker,
          ...s.trackers,
        ].slice(0, 24),
      };
    }),

  remove: (id) => set((s) => ({ trackers: s.trackers.filter((t) => t.id !== id) })),

  activeForDoc: (docId) =>
    get().trackers.some(
      (t) => t.docId === docId && (t.status === "queued" || t.status === "running"),
    ),
}));
